import { useMutation } from "react-query";
import api from "../../utils/api";

export default function useDelete(url) {
  return useMutation((payload) =>
    api.delete(url, {
      data: payload,
    })
  );
}
